import React from 'react'

export const Check = () => {
  return (
    <svg width='14' height='15' viewBox='0 0 14 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 7.25C0 3.39453 3.11719 0.25 7 0.25C10.8555 0.25 14 3.39453 14 7.25C14 11.1328 10.8555 14.25 7 14.25C3.11719 14.25 0 11.1328 0 7.25ZM10.1445 6.04688C10.4453 5.74609 10.4453 5.28125 10.1445 4.98047C9.84375 4.67969 9.37891 4.67969 9.07812 4.98047L6.125 7.93359L4.89453 6.73047C4.59375 6.42969 4.12891 6.42969 3.82812 6.73047C3.52734 7.03125 3.52734 7.49609 3.82812 7.79688L5.57812 9.54688C5.87891 9.84766 6.34375 9.84766 6.64453 9.54688L10.1445 6.04688Z'
        fill='#41D578'
      />
    </svg>
  )
}
